import { render, staticRenderFns } from "./DataSecurityController.vue?vue&type=template&id=5a1e892a&scoped=true"
import script from "./DataSecurityController.vue?vue&type=script&lang=ts"
export * from "./DataSecurityController.vue?vue&type=script&lang=ts"
import style0 from "./DataSecurityController.vue?vue&type=style&index=0&id=5a1e892a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1e892a",
  null
  
)

export default component.exports